import { ExpectedTaskAnswerMetadata, Task } from "@jelly/lesson";

const items = [
  {
    id: "d9c8fb2c-a810-4813-a495-0a3b5820aac4",
    content: "A → one reflection<br>B → one reflection<br>C → two reflections",
    options: {},
  },
  {
    id: "f9a93945-e362-45a6-9792-4a4ff7b1eb44",
    content: "A → one reflection<br>B → two reflections<br>C → one reflection",
    options: {},
  },
  {
    id: "a2d576f6-024f-400e-9488-ef07cb8760d1",
    content: "A → two reflections<br>B → one reflection<br>C → two reflections",
    options: {},
  },
  {
    id: "7a66ba73-b33e-462e-8413-bb3e4bbd4e27",
    content: "A → two reflection<br>B → two reflections<br>C → one reflection",
    options: {},
  },
];

export const task: Task = {
  id: "40575a1f-85d2-4364-98db-28a35ac23df8",
  solutionType: "select",
  type: "checkbox",
  options: {
    shuffle: true,
    isMultiple: false,
    columns: 4,
  },
  items,
};

export const expectedAnswerMetadata: ExpectedTaskAnswerMetadata = {
  solutionType: "select",
  data: ["a2d576f6-024f-400e-9488-ef07cb8760d1"],
};
